import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
})
export class LogoutComponent implements OnInit {
  constructor() {
    return;
  }

  ngOnInit(): void {
    return;
  }
}
